'use strict';

angular.module('core').controller('OnboardingController', [
	'$scope',
	'$state',
	'$stateParams',
	'EntryMain',
	'EventTracker',
	'FileUploader',
	'Utilities',
	'TranslationImport',
	'ALLOWED_IMPORT_FILE_EXTENSIONS',
	'DEFAULT_TAG_CATEGORIES',
	function(
		$scope,
		$state,
		$stateParams,
		EntryMain,
		EventTracker,
		FileUploader,
		Utilities,
		TranslationImport,
		ALLOWED_IMPORT_FILE_EXTENSIONS,
		DEFAULT_TAG_CATEGORIES
	) {

		$scope.player = undefined;

		$scope.appId = $stateParams.mobileAppId;

		$scope.draftKey = 'unknown';

		$scope.showIosVideo = false;

		$scope.activeTab = 'iOS';

		$scope.tagCategories = angular.copy(DEFAULT_TAG_CATEGORIES);

		function replaceIframe(){
			$scope.player = new window.YT.Player('onboarding-video', {
				height: '315',
				width: '560',
				videoId: 's9S7fty-X7U'
			});
		}

		/**
		 * Adds the video to the page
		 */
		function addVideo() {
			// Load the script that is needed to use the YouTube API
			var tag = document.createElement('script');
			tag.src = 'https://www.youtube.com/iframe_api';
			var firstScriptTag = document.getElementsByTagName('script')[0];
			firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

			// Create the player and load the video
			window.onYouTubeIframeAPIReady = function() {
				replaceIframe();
			};
		}

		/**
		 * Initializes the uploader data
		 */
		function initUploader() {

			var uploader = $scope.uploader = new FileUploader();

			// FILTERS
			uploader.filters.push({
				name: 'dataFilter',
				fn: function(item) {
					var type = item.name.slice(item.name.lastIndexOf('.') + 1);
					return ALLOWED_IMPORT_FILE_EXTENSIONS.indexOf(type) !== -1;
				}
			});

			// CALLBACKS
			uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
				console.info('onWhenAddingFileFailed', item, filter, options);
				$scope.errorMessage = 'The file you tried to upload is currently not supported. Please upload files of the following types: "' + ALLOWED_IMPORT_FILE_EXTENSIONS.join('", "') + '"';

			};
			uploader.onAfterAddingFile = function(fileItem) {
				// Get the base language
				var baseLanguage;
				for (var languageId in EntryMain.languages) {
					baseLanguage = EntryMain.languages[languageId];
					if (baseLanguage.name === $scope.mobileApp.baseLanguage) {
						break;
					}
				}

				var importer = new TranslationImport($scope.mobileApp, EntryMain.defaultGroup, baseLanguage, {}, $scope.tagCategories);

				var options = {};
				importer.importFileWithOptions(fileItem._file, [], options).then(
					function(data) {
						//$state.go('viewMobileApp', {mobileAppId: $scope.mobileApp._id});
						let url = `!/#/projects/${$scope.mobileApp._id}`;
						location.href = url;
					}
				).catch(function (error) {
					Utilities.showMessageErrorResponse(error);
				});

			};
		}

		function init() {
			initUploader();

			EntryMain.loadMobileApp($stateParams.mobileAppId).then(
				function(mobileApp) {
					$scope.mobileApp = mobileApp;
					$scope.draftKey = mobileApp.apiSecret.slice(0,4);
				}
			).catch(function(error) {
				Utilities.showMessage(
					'Error!',
					'There was a problem loading the app!',
					'error'
				);
				$scope.draftKey = 'not found';
			});

			addVideo();
		}

		/**
		 * Shows and hides the video and automatically starts and stops it
		 * accordingly
		 */
		$scope.toggleVideo = function() {
			$scope.showIosVideo = !$scope.showIosVideo;
			
			// Check if the player instance is really there. Because if people
			// click very fast, it is possible that it did not have time to
			// load and it would then error.
			if ($scope.player) {
				if ($scope.showIosVideo) {
					$scope.player.playVideo();
				} else {
					$scope.player.pauseVideo();
				}
			} else {
				replaceIframe();
			}
		};


		/**
		 * Executes whenever a different tab gets selected and tracks it
		 */
		$scope.tabSelected = function(tabName) {
			$scope.activeTab = tabName;

			// Track whenever a different tab gets selected
			var eventData = {
				tab: tabName
			};
			EventTracker.track('Tab Changed', 'Onboarding', eventData);
		};


		/**
		 * Executes whenever specific buttons get pressed and tracks it
		 */
		$scope.buttonClicked = function(buttonName) {
			// Track whenever something gets clicked
			var eventData = {
				buttonName: buttonName
			};
			EventTracker.track('Click', 'Onboarding', eventData);
		};


		$scope.tryAgain = function() {
			$scope.errorMessage = '';
			initUploader();
		};

		init();
	}
]);
